// Where the round state comes from. The table used to ask the server every 750ms whether anything had
// happened, which is both the reason a change took up to three quarters of a second to appear and the
// reason a poll that left before your tap could answer after it and undo what you did. Now the server
// pushes: a write publishes the new state to everyone in the room and it lands within a few milliseconds.
//
// The poll has not been deleted, it has been demoted to the fallback. A phone that cannot hold a websocket
// open (a captive portal, a proxy that strips the upgrade) keeps working the way it always did rather than
// showing a table that silently stops updating.
const ROUND_POLL_MS = 750;

let roundConnection: signalR.HubConnection | null = null;
let roundPollTimer = 0;

function StartRoundFeed(): void {
    if (typeof signalR === "undefined") {
        StartRoundPolling();
        return;
    }

    const connection = new signalR.HubConnectionBuilder()
        .withUrl("/hubs/round")
        .withAutomaticReconnect()
        .build();

    roundConnection = connection;
    connection.on("roundChanged", OfferRound);
    connection.onreconnecting(StartRoundPolling);
    connection.onreconnected(JoinRoundRoom);
    connection.onclose(StartRoundPolling);

    connection.start()
        .then(JoinRoundRoom)
        .catch(StartRoundPolling);
}

// Joining answers with the current state, so this doubles as the first read. It also runs again after every
// reconnect: a connection that comes back is not in its group anymore, and it missed whatever happened
// while it was away.
function JoinRoundRoom(): void {
    if (!roundConnection) {
        return;
    }

    roundConnection.invoke<RoundResponse>("JoinRoom", RoomKey())
        .then(round => {
            StopRoundPolling();
            OfferRound(round);
        })
        .catch(StartRoundPolling);
}

// Drawing only. Whether a state should be drawn at all is OfferRound's decision.
function RenderRound(round: RoundResponse): void {
    SetRoundDetails(round.roundNumber, round.players.concat(round.monsters), round.elements, ParticipantRole());
}

function StartRoundPolling(): void {
    if (roundPollTimer) {
        return;
    }

    PollRoundOnce();
}

function PollRoundOnce(): void {
    GetRound();
    roundPollTimer = setTimeout(PollRoundOnce, ROUND_POLL_MS);
}

function StopRoundPolling(): void {
    clearTimeout(roundPollTimer);
    roundPollTimer = 0;
}
